import UpsLogo from 'images/zappos/ups-logo.svg';
import { ups } from 'styles/components/account/returns/returnsAndExchanges.scss';

const UPSBanner = () => (
  <div className={ups}>
    <img src={UpsLogo} alt="UPS"/>
    <span>We provide shipping labels using UPS for easy, fast, and secure shipping and package tracking.</span>
  </div>
);

export default UPSBanner;
